import {
  DESERIALIZATION_SCHEMA_MISMATCH,
  DESERIALIZATION_VALIDATION_ERROR,
} from 'app/constants/ServerErrors';
import ApplicationError from 'app/models/request/ApplicationError';
import { Entity } from 'app/types/entity';
import { IError } from 'app/constants/schemas/Error';

export const onlyApplicationError = (responseError: unknown): Entity<IError> | null => {
  if (responseError instanceof ApplicationError && !responseError.isAggregation()) {
    return responseError.error;
  } else {
    return null;
  }
};

export const containsSchemaMismatch = (errorResponse: unknown): boolean => {
  if (errorResponse instanceof ApplicationError) {
    return errorResponse.codes.includes(DESERIALIZATION_SCHEMA_MISMATCH);
  }
  return false;
};

export const isValidationError = (error: unknown) => Boolean(
  error instanceof ApplicationError && (
    error.code === DESERIALIZATION_VALIDATION_ERROR ||
    (error.isAggregation() && error.causes?.every(e => e.code === DESERIALIZATION_VALIDATION_ERROR))
  ),
);
